import { render } from "./hisBooks.vue?vue&type=template&id=283b37a2&scoped=true"
import script from "./hisBooks.vue?vue&type=script&lang=js"
export * from "./hisBooks.vue?vue&type=script&lang=js"

import "./hisBooks.vue?vue&type=style&index=0&id=283b37a2&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283b37a2"]])

export default __exports__